export default "__VITE_ASSET__CSPPQ0_5__"